// ESM-Huelle um lib/scripts/pos/CLS_CInfoIcons.js (Phase 4, Welle 4b).
// Prototype-Stil bleibt vorerst.
function CInfoIcons(userId) {
	this.Main = POS.sessions.openSessions[userId];

	// Specific for button "customer"
	this.customerDataOn = false;

	// Specific for button "suggestion"
	this.lastSuggestionTimeout = null;

	// Specific for button "rebate"
	this.rebatesDataOn = false;
	this.flagLastRebatesUpdate = false;
	this.changingRebates = null;
	this.hours = null;
	this.minutes = null;
}

CInfoIcons.prototype.hideAllInfoIcons = function () {
	for (var i = 0; i < this.Main.components.infoIcons.children.length; i++)
		this.Main.components.infoIcons.children[i].setEnabled(false);
}

CInfoIcons.prototype.highlightIcon = function (iconName, userId, timeout) {
	var iconInfo = this.getIconInfo(iconName);

	this.Main.components.infoIcons.children[iconInfo.iconIndex].properties.styles.backgroundImage = iconInfo.activeImage;
	this.Main.components.infoIcons.children[iconInfo.iconIndex].setEnabled(true);
	
	if (!timeout)
		return;

	var lastTimeout = window.setTimeout("POS.sessions.openSessions[" + userId +
			"].InfoIcons.hideIcon('" + iconName + "')", timeout);

	if (iconName == "suggestion")
		this.lastSuggestionTimeout = lastTimeout;
}

CInfoIcons.prototype.hideIcon = function (iconName) {
	var iconInfo = this.getIconInfo(iconName);

	this.Main.components.infoIcons.children[iconInfo.iconIndex].properties.styles.
	backgroundImage = iconInfo.inactiveImage;
	this.Main.components.infoIcons.children[iconInfo.iconIndex].setEnabled(false);

	if (iconName == "suggestion" && this.lastSuggestionTimeout)
		window.clearTimeout(this.lastSuggestionTimeout);
	if (iconName == "customer")
		this.customerDataOn = false;
	else if (iconName == "rebate")
		this.rebatesDataOn = false;
}

CInfoIcons.prototype.getIconInfo = function (iconName) {
	var parameters = new Array("iconIndex", "activeImage", "inactiveImage");

	switch (iconName) {
	case "cashbox":
		parameters.iconIndex = 0;
		parameters.activeImage = "url(lib/img/alertIcons/cashbox_active.png)";
		parameters.inactiveImage = "url(lib/img/alertIcons/cashbox_inactive.png)";
		break;
	case "import":
		parameters.iconIndex = 1;
		parameters.activeImage = "url(lib/img/alertIcons/import_active.gif)";
		parameters.inactiveImage = "url(lib/img/alertIcons/import_inactive.gif)";
		break;
	case "suggestion":
		parameters.iconIndex = 2;
		parameters.activeImage = "url(lib/img/alertIcons/boninfo_active.gif)";
		parameters.inactiveImage = "url(lib/img/alertIcons/boninfo_inactive.gif)";
		break;
	case "rebate":
		parameters.iconIndex = 3;
		parameters.activeImage = "url(lib/img/alertIcons/rebate_active.gif)";
		parameters.inactiveImage = "url(lib/img/alertIcons/rebate_inactive.gif)";
		break;
	case "email":
		parameters.iconIndex = 4;
		parameters.activeImage = "url(lib/img/alertIcons/message_active.gif)";
		parameters.inactiveImage = "url(lib/img/alertIcons/message_inactive.gif)";
		break;
	case "customer":
		// Rueckt am 26.8.2026 von 6 auf 5: das Funkscanner-Symbol dazwischen
		// ist mit dem Geraet entfallen.
		parameters.iconIndex = 5;
		parameters.activeImage = "url(lib/img/alertIcons/customer_active.gif)";
		parameters.inactiveImage = "url(lib/img/alertIcons/customer_inactive.gif)";
		break;
	}

	return parameters;
}

CInfoIcons.prototype.makeInfoIcons = function () {
	var xml = new CXmlHandler("etc/layout/LYT_infoIcons.xml");

	var btns = new Array();

	var xmlBtns = xml.rootElement.getElementsByTagName("button");

	for (var n = 0; n < xmlBtns.length; n++) {
		btns[n] = new CPushButton(this.Main.id);
		btns[n].properties = combine(btns[n].properties,
				xml.getObject(xmlBtns[n], false)["button"]);
		btns[n].properties.attributes.onMousedown_parameter_0 = this.Main.id;
		btns[n].properties.styles.borderRadius = "0px";
		btns[n].properties.disableType = "LOCK";
	}

	btns[0].properties.events.onMousedown = this.closeCashbox;
	btns[1].properties.events.onMousedown = this.manualImport;//POS.DataImport.manualImportData;
	btns[2].properties.events.onMousedown = this.acceptSuggestion;
	btns[3].properties.events.onMousedown = this.showRebatesInfo;
	btns[4].properties.events.onMousedown = this.inbox;
	// NUMMERIERUNG: Das Funkscanner-Symbol sass auf Index 5 und ist am
	// 26.8.2026 mit dem Geraet entfallen - das Kundensymbol rueckt von 6 auf
	// 5 auf. Die Handler haengen ALLEIN am Index; ohne diese Anpassung starb
	// makeInfoIcons an btns[6] ("Cannot read properties of undefined"),
	// und zwar direkt beim Login.
	btns[5].properties.events.onMousedown = this.customerData;

	return btns;
}

CInfoIcons.prototype.closeCashbox = function (component, parameters) {
	// does nothing
}

CInfoIcons.prototype.manualImport = function () {
	 new CDataImport().manualImportData();
}


CInfoIcons.prototype.showRebatesInfo = function (component, parameters) {
	var Main = POS.getComponentById(parameters[0]);
	var me = Main.InfoIcons;

	if (me.rebatesDataOn == true)
		return;
	else
		me.rebatesDataOn = true;

	var cmp = Main.addChild(CRebatesInfoMode);
	cmp.changingRebates = me.changingRebates;
	cmp.draw();
	cmp.drawRebatesInfo(me.hours, me.minutes);
}

CInfoIcons.prototype.acceptSuggestion = function (component, parameters) {
	var Main = POS.getComponentById(parameters[0]);

	Main.BonManager.acceptSuggestion();
}

CInfoIcons.prototype.inbox = function (component, parameters) {
	var message = new MessageFunctions();
	message.init((POS.POSType=='Master')?POS.POSId:POS.MasterID,POS.sessions.currentSession);
}

// CInfoIcons.doInbox (CMessageReader-Posteingang) ist am 23.8.2026
// entfallen: der einzige Aufrufer war schon lange auskommentiert, der
// Nachrichten-Knopf oben nutzt MessageFunctions.

CInfoIcons.prototype.customerData = function (components, parameters) {
	var Main = POS.getComponentById(parameters[0]);
	var me = Main.InfoIcons;

	if (me.customerDataOn == true)
		return;
	else
		me.customerDataOn = true;

	var cmp = Main.addChild(CCustomerDataMode);
	cmp.customerId = Main.BonManager.currentCustomerId;
	cmp.draw();
	cmp.drawCustomerData();
}

CInfoIcons.prototype.clearLastSuggestionTimeout = function (components, parameters) {
	if (this.lastSuggestionTimeout)
		window.clearTimeout(this.lastSuggestionTimeout);
}

CInfoIcons.prototype.showNewMessagePopup = function(userId) {
    if ($('#mbtabs').length > 0) return;

    var me = this;
    var posid = (POS.POSType === 'Master') ? POS.POSId : POS.MasterID;
    var userid = POS.sessions.currentSession;

    var d = new Date();
    d.setFullYear(d.getFullYear() - 1);
    var newDate = new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
    var date = newDate.toISOString().substring(0, 19);

    var sql =
        "SELECT id, object, post_text, owner, posid_sent, 'personal' as msgtype FROM messageboard.posts " +
        "WHERE receiver=" + userid + " AND (has_read IS NULL OR has_read=0) AND (create_time>'" + date + "' OR permanent=1) " +
        "UNION ALL " +
        "SELECT p.id, p.object, p.post_text, p.owner, p.posid_sent, 'pos' as msgtype FROM messageboard.posts p " +
        "LEFT JOIN messageboard.messages_read r ON (r.message_id=p.id AND r.POS_ID=" + posid + ") " +
        "WHERE p.posid_recv=" + posid + " AND r.message_id IS NULL AND (p.create_time>'" + date + "' OR p.permanent=1) " +
        "UNION ALL " +
        "SELECT p.id, p.object, p.post_text, p.owner, p.posid_sent, 'common' as msgtype FROM messageboard.posts p " +
        "LEFT JOIN messageboard.messages_read r ON (r.message_id=p.id AND r.POS_ID=" + posid + ") " +
        "WHERE (p.receiver=999999 OR p.receiver=999998) AND r.message_id IS NULL AND (p.create_time>'" + date + "' OR p.permanent=1) " +
        "ORDER BY id DESC";

    new CRunClient().sendQuery(sql, function(rows) {
        if (!rows || rows.length === 0) return;
        me._showNextMessagePopup(rows, 0, posid);
    }, "messageboard");
};

CInfoIcons.prototype._showNextMessagePopup = function(messages, index, posid) {
    if (index >= messages.length) return;

    var me = this;
    var msg = messages[index];

    var from = (parseInt(msg.owner) > 0) ? msg.owner : ('POS_' + msg.posid_sent);
    if (msg.owner == 0 || msg.posid_sent == 0) from = 'Zentrale';

    $('#msg-notification-popup').remove();
    var popup = $('<div id="msg-notification-popup">').css({
        position: 'fixed',
        top: '10%',
        left: '20%',
        width: '60%',
        backgroundColor: '#fffbe6',
        border: '3px solid #cc9900',
        borderRadius: '8px',
        padding: '20px',
        zIndex: 9999,
        fontSize: '1.8vh',
        boxShadow: '0 4px 16px rgba(0,0,0,0.4)'
    });

    popup.html(
        '<div style="font-size:2.2vh;font-weight:bold;margin-bottom:12px;">&#9993;&nbsp;Neue Nachricht (' + (index + 1) + ' von ' + messages.length + ')</div>' +
        '<div><b>Von:</b>&nbsp;' + from + '</div>' +
        '<div><b>Betreff:</b>&nbsp;' + msg.object + '</div>' +
        '<hr style="margin:10px 0;">' +
        '<div style="max-height:250px;overflow-y:auto;line-height:1.5;">' + (msg.post_text || '') + '</div>' +
        '<div style="margin-top:16px;text-align:right;">' +
        '<button id="msg-popup-ok" style="font-size:2vh;padding:10px 28px;cursor:pointer;background:#4CAF50;color:white;border:2px solid #388E3C;border-radius:6px;font-weight:bold;">Verstanden</button>' +
        '</div>'
    );

    $('body').append(popup);

    $('#msg-popup-ok').on('mousedown', function() {
        me._markMessageRead(msg, posid);
        popup.remove();
        me._showNextMessagePopup(messages, index + 1, posid);
    });
};

CInfoIcons.prototype._markMessageRead = function(msg, posid) {
    var sql;
    if (msg.msgtype === 'personal') {
        sql = "UPDATE messageboard.posts SET has_read=1 WHERE id=" + msg.id;
    } else {
        sql = "INSERT IGNORE INTO messageboard.messages_read (message_id, POS_ID) VALUES (" + msg.id + "," + posid + ")";
    }
    new CRunClient().sendQuery(sql, null, "messageboard");
};

export { CInfoIcons };
